import { render, staticRenderFns } from "./FailurePart.vue?vue&type=template&id=34652f44"
import script from "./FailurePart.vue?vue&type=script&lang=js"
export * from "./FailurePart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports